export default {
  'system.error': 'Something has gone wrong',

  'form.sign-in.login.label': 'Log In',
  'form.sign-in.login.email': 'Email',
  'form.sign-in.login.password': 'Password',

  'alert.sign-in.login.success': 'Log in successful',
  'alert.sign-in.login.failed': 'Log in failed',

  'page.orders.no_order': "You don't have any order yet.",

  'page.coupon.instruction': 'Please show this page to server to redeem your offer',
  'page.coupon.redeem.button': 'Redeem',
  'page.coupon.redeem.button.used': 'Used',
  'page.coupon.slogan': 'Authentic cuisine delivered.',
  'page.coupon.first_order_discount': 'First order $10 coupon:',
  'page.coupon.failed.load': 'Failed to load coupon',

  'page.address.no_restaurant': 'There seems to be no restaurant near your location.',

  'page.checkout.no_address': 'Missing delivery address',
  'page.checkout.verify_phone_number.dialog.title': 'Verify phone number',
  'page.checkout.phone_number.title': 'Phone Number',
  'page.checkout.phone_number.phone_number_on_file': 'Phone Number on file:',
  'page.checkout.phone_number.add_phone_number': 'Add phone number',
  'page.checkout.phone_number.verify_phone_number': 'Verify phone number',

  'page.confirmation.delivery.has_finished': 'Your order has been finished',
  'page.confirmation.delivery.is_not_available_yet':
    'Driver information will be available once delivery starts',

  'page.reset-password.title': 'Reset Password',
  'page.reset-password.introduction':
    'Enter your account email for security reasons, we will send a verification code to your email.',
  'page.reset-password.next': 'Next',

  'page.verification.title': 'User Verification',
  'page.verification.introduction':
    'We sent a code to { sentCodeToEmail }. Please enter the code below',
  'page.verification.reset_code': 'Resend code',
  'page.verification.next': 'Next',

  'page.reward.instruction': '{name} has sent you a reward from {restaurantNames}!',
  'page.reward.instruction.used': 'Sorry, this reward has been redeemed, please try other reward.',
  'page.reward.instruction.redeemed': 'Yay! you have redeemed this reward!',
  'page.reward.input.phonelabel': 'Please enter your phone.',
  'usedpage.reward.button.used': 'Used',
  'page.reward.qrcode.press_to_download': 'Long press QR code to download Chowbus App',
  'page.reward.button': 'Redeem',
  'page.reward.redeem.alert.success': 'Redeem successfully, check your app for the rewards.',
  'page.reward.redeem.alert.failed': 'Redeem failed.',
  'page.reward.first_order_discount':
    'Use promo code {invitationCode} to get $10 off your first order',
  'page.reward.download': 'Go to download',
  'page.reward.service.title': 'Our Services',
  'page.reward.service.delivery': 'No small cart fee',
  'page.reward.service.pickup': 'Skip the line and get up to 10% off every pickup order',
  'page.reward.service.dineIn': 'Pre-order and get exclusive discounts',
  'page.reward.service.Grocery': 'Conveniently delivered to you from your local stores',
  'page.reward.uniqueness.title': 'Our Uniqueness',

  'actions.shoppingCart.different_service_type.title': 'Checkout before continue',
  'actions.shoppingCart.different_service_type.message':
    'You have item(s) in your shopping cart, do you want to check out before continue?',
  'actions.shoppingCart.delivery_group_missed.title': 'Checkout before continue',
  'actions.shoppingCart.delivery_group_missed.message':
    'You have item(s) in your shopping cart, do you want to check out before continue?',
  'actions.shoppingCart.stop_missed.title': 'Checkout before continue',
  'actions.shoppingCart.stop_missed.message':
    'You have item(s) in your shopping cart, do you want to check out before continue?',

  'actions.shoppingCart.no_available_time.title': 'No available service time',
  'actions.shoppingCart.no_available_time.content':
    "We're sorry, but this restaurant has been closed, please check out another restaurant",
  'actions.shoppingCart.no_payment.title': 'Missing payment',
  'actions.shoppingCart.no_payment.content': 'Please select a payment method',
  'actions.shoppingCart.checkout': 'Checkout',
  'actions.shoppingCart.order_has_been_placed': 'Order has been placed successfully',
  'actions.shoppingCart.clear_cart': 'Clear cart',

  'actions.signup.success': 'Sign up successfully',
  'actions.signup.failed': 'Failed to sign up',
  'actions.signup.phone_number.invalid': 'Phone number is invalid',
  'actions.signup.email.invalid': 'Email is invalid',
  'actions.signup.email_phone.taken': 'Phone number or email is taken',

  'actions.user.addresses.delete.success': 'Address has been deleted.',
  'actions.user.addresses.delete.failed': 'Failed to delete address.',
  'actions.user.addresses.update.success': 'Address has been updated',
  'actions.user.addresses.update.failed': 'Failed to update address',

  'actions.user.verification.phone_number.code_send.success':
    'A verification code has been sent to your phone.',
  'actions.user.verification.phone_number.code_send.failed': 'Failed to send verification code',
  'actions.user.verification.phone_number.success': 'Your phone number has been verified',
  'actions.user.verification.phone_number.failed': 'Code is not correct',

  'actions.payment.get.success': 'Get payments successfully',
  'actions.payment.get.failed': 'Failed to get payments',

  'actions.user.address.error.alert': 'Please enter your delivery address',

  'actions.delivery.address_error_dialog_title':
    "You are outside of {restaurantName}'s delivery zone",
  'actions.delivery.no_address':
    "Please enter the delivery address below to see if you are within {restaurantName}'s delivery zone.",
  'actions.delivery.address_not_specific':
    'Looks like we need a more specific delivery address. Please update your address and try again',
  'actions.delivery.invalid_address':
    "Unfortunately, your saved address is outside of {restaurantName}'s delivery zone. Update the address if it's outdated or pick another restaurant ",
  'actions.delivery.invalid_address_again':
    'Oh no! You are still out of the delivery zone. Please try one of the many delicious restaurants on Chowbus.',
  'actions.delivery.back_to_restaurants': 'Back to Restaurants',
  'actions.delivery.goto_all': 'Go to All Restaurants',

  'password.requirement.title': 'Password Must: ',
  'password.requirement.strength.title': 'Password Strength',
  'password.requirement.strength.week': 'Weak',
  'password.requirement.strength.medium': 'Medium',
  'password.requirement.strength.strong': 'Strong',
  'password.requirement.rule.min-characters': 'Have at least 8 Characters',
  'password.requirement.rule.min-lowercase': 'Include at least 1 lowercase letter',
  'password.requirement.rule.min-uppercase': 'Include at least 1 uppercase letter',
  'password.requirement.rule.min-number': 'Include at least 1 number',

  'form.validation.rule.required': 'Required',
  'form.validation.rule.must-match-field': 'Match',
  'form.validation.rule.invalid-email': 'Invalid Email',
  'form.validation.rule.invalid-phone-number': 'Invalid Phone Number',
  'form.validation.rule.valid-phone-number': 'Valid Phone Number',

  'actions.new_address.invalid_address':
    "Unfortunately, your address is outside of delivery zone. Update the address if it's outdated",

  'page.crm.phohebining.toptitle0': 'Join ',
  'page.crm.phohebining.toptitle1': ' Membership for Free',

  'page.crm.phohebining.earn_points_and_redeem': 'You can also earn points and redeem free dishes!',

  'page.crm.phohebining.promotion0': 'You spent ',
  'page.crm.phohebining.promotion1': ' for this order ',
  'page.crm.phohebining.promotion2': ', you are only ',
  'page.crm.phohebining.promotion3': ' away from lifetime discount',

  'page.crm.phohebining.promotion4': ' ',
  'page.crm.enter.phone.placeholder': 'Phone',
  'page.crm.join.member.button': 'Join Membership',

  'page.crm.join.done.title': 'Join Successfully',
  'page.crm.join.done.desc': 'Congratulations on joining {restaurantName} membership',
  'page.crm.join.done.ok.button': 'OK',
};
